<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span v-if="$route.meta.rtlActive">
          {{ rtlTitle }}
          <b class="caret"></b>
        </span>
        <span v-else>
          {{ title }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <!-- <a v-if="$route.meta.rtlActive" @click="goToProfile">
                  <span class="sidebar-mini">مع</span>
                  <span class="sidebar-normal">ملف</span>
                </a>
                <a v-else @click="goToProfile">
                  <span class="sidebar-mini">MP</span>
                  <span class="sidebar-normal">Mój Profil</span>
                </a> -->
                <router-link to="/user-profile">
                  <span class="sidebar-mini">
                    <md-icon>
                      <md-avatar style="height: 32px; width: 32px; margin-top: -5px;">
                        <img :src="myProfileIcon" alt="Avatar">
                      </md-avatar>
                    </md-icon>
                  </span>
                  <span class="sidebar-normal">Dane Administratora</span>
                </router-link>
              </li>
              <li>
                <router-link to="/customer-profile">
                  <span class="sidebar-mini">
                    <md-icon>
                      <md-avatar style="height: 32px; width: 32px; margin-top: -5px;">
                        <img :src="myCompanyIcon" alt="Avatar">
                      </md-avatar>
                    </md-icon>
                  </span>
                  <span class="sidebar-normal">Dane Firmy</span>
                </router-link>
              </li>
              <li>
                <a v-if="$route.meta.rtlActive" @click="logout">
                  <span class="sidebar-mini">و</span>
                  <span class="sidebar-normal">إعدادات</span>
                </a>
                <a v-else @click="logout">
                  <span class="sidebar-mini">
                    <md-icon>
                      <md-avatar style="height: 32px; width: 32px; margin-top: -5px;">
                        <img :src="logoutIcon" alt="Avatar">
                      </md-avatar>
                    </md-icon>
                  </span>
                  <span class="sidebar-normal">Wyloguj</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
export default {

  data() {
    return {
      isClosed: true,
      title: 'Profile',
      rtlTitle: "تانيا أندرو",
      avatar: `${process.env.VUE_APP_BASE_URL}/img/placeholder.jpg`,
      myProfileIcon: process.env.VUE_APP_BASE_URL + '/img/icons/menu/my-profile.svg',
      myCompanyIcon: process.env.VUE_APP_BASE_URL + '/img/icons/menu/my-company.svg',
      logoutIcon: process.env.VUE_APP_BASE_URL + '/img/icons/menu/logout.svg',
    };
  },

  async created() {
    this.$store.watch(() => this.$store.getters["profile/me"], (me) => {
      // this.title = me.name // Get user name 
      this.title = me.customer_taxid // Get taxid instead of user name
      if (me.profile_image) {
        this.avatar = me.profile_image
      } else {
        this.avatar = `${process.env.VUE_APP_BASE_URL}/img/placeholder.jpg`;
      }
    })
    await this.$store.dispatch("profile/me")
  },

  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
    goToProfile() {
      this.$router.push({name: "User Profile"})
    },
    logout() {
      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
        },
      };

      this.$store.dispatch("logout", { requestOptions });
    }
  }
}
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
